import Layout from '../layout/index.vue'

export default [
	{
		path: '/dispatch',
		name: 'Supervision',
		component: Layout,
		redirect: 'dispatch/index',
		children: [
			{
				path: 'index',//列表
				component: () => import('../views/dispatch/index')
			},
			{
				path: 'edit',//编辑
				component: () => import('../views/dispatch/edit')
			},
			{
				path: 'editNew',//编辑
				component: () => import('../views/dispatch/editNew')
			},
			
			{
				path: 'report',//报表
				component: () => import('../views/dispatch/report')
			},
			{
				path: 'setting',//驻场分管领导
				component: () => import('../views/dispatch/setting')
			},
			{
				path: 'useredit',//驻场分管领导
				component: () => import('../views/dispatch/useredit')
			},
			
			{
				path: 'user',//驻场分管领导
				component: () => import('../views/dispatch/user')
			},
			
			
		]
	},
];